import { DefaultError, useQuery } from '@tanstack/react-query';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ILabelLight} from './types';
import { apiClient } from 'utils';

export const useGetLabelLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ILabelLight[], DefaultError>({
    queryKey: ['label-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Label/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetLabelLightList`,
      });
    },
  });
};
